import IconEmpty from '../../../../assets/Images/icons/empty';
import { Pagination } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { REGISTER_ID } from '../../REGISTER_ID';
import { ROUTER } from '../../../../constants/router';
import classNames from 'classnames';
export default function ListCardTab1({
    dataSource,
    currentPage,
    setCurrentPage,
    setLoading,
    total,
}) {
    const { t, i18n } = useTranslation();
    const getStatusColor = (e) => {
        switch (e) {
            case REGISTER_ID.UNREGISTER:
                return '#B7B7C0';
            case REGISTER_ID.IN_PROGRESS:
                return '#F9C153';
            case REGISTER_ID.REGISTERED:
                return '#4ACE8F';
            default:
                return '#FFFFFF';
        }
    };

    return (
        <>
            <div className="overflow-auto max-h-[37vh] grid gap-3 p-4">
                {dataSource?.length > 0 ? (
                    dataSource?.map((item, index) => (
                        <>
                            <Link
                                to={`${ROUTER.RISK_MANAGEMENT.RA}/ra/${item.activityId}/view`}
                                className="text-black"
                            >
                                <div
                                    className={classNames(
                                        'border-hover flex bg-white w-full py-4 px-3 rounded-lg space-x-3 cursor-pointer transform duration-300 hover:scale-[1.01]'
                                    )}
                                >
                                    <div className="w-full">
                                        <a className="font-semibold text-sm text-purple">
                                            {item?.activityName || '-'}
                                        </a>

                                        <div className="grid grid-cols-2 mt-2">
                                            <div className="space-y-2">
                                                <div className="grid grid-cols-2 text-xs">
                                                    <strong className="text-xs">
                                                        {t(
                                                            'RA.RiskRegisterCode'
                                                        )}{' '}
                                                        :
                                                    </strong>
                                                    <div>
                                                        {item?.riskRegisterNumber ||
                                                            '-'}
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-2 text-xs">
                                                    <strong className="text-xs">
                                                        {t('Department')} :
                                                    </strong>
                                                    <div>
                                                        {i18n.language === 'en'
                                                            ? item?.departmentEn
                                                                ? item?.departmentEn
                                                                : '-'
                                                            : item?.departmentTh
                                                            ? item?.departmentTh
                                                            : '-'}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="space-y-2">
                                                <div className="grid grid-cols-1 text-xs">
                                                    <div className="flex space-x-2 w-full rounded-lg">
                                                        <div className="flex items-center h-full">
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="10"
                                                                    fill={getStatusColor(
                                                                        item?.statusId
                                                                    )}
                                                                />
                                                                <path
                                                                    d="M14.473 6.80667C14.411 6.74418 14.3373 6.69459 14.256 6.66074C14.1748 6.62689 14.0876 6.60947 13.9996 6.60947C13.9116 6.60947 13.8245 6.62689 13.7433 6.66074C13.662 6.69459 13.5883 6.74418 13.5263 6.80667L8.55964 11.78L6.47297 9.68667C6.40863 9.62451 6.33267 9.57563 6.24943 9.54283C6.16619 9.51003 6.07731 9.49394 5.98786 9.49549C5.8984 9.49704 5.81013 9.51619 5.72808 9.55185C5.64602 9.58751 5.5718 9.63899 5.50964 9.70333C5.44748 9.76768 5.39861 9.84364 5.3658 9.92688C5.333 10.0101 5.31691 10.099 5.31846 10.1885C5.32001 10.2779 5.33916 10.3662 5.37482 10.4482C5.41049 10.5303 5.46196 10.6045 5.52631 10.6667L8.08631 13.2267C8.14828 13.2892 8.22202 13.3387 8.30326 13.3726C8.3845 13.4064 8.47163 13.4239 8.55964 13.4239C8.64765 13.4239 8.73479 13.4064 8.81603 13.3726C8.89727 13.3387 8.971 13.2892 9.03297 13.2267L14.473 7.78667C14.5406 7.72424 14.5946 7.64847 14.6316 7.56414C14.6685 7.47981 14.6876 7.38874 14.6876 7.29667C14.6876 7.2046 14.6685 7.11353 14.6316 7.0292C14.5946 6.94486 14.5406 6.8691 14.473 6.80667V6.80667Z"
                                                                    fill="white"
                                                                />
                                                            </svg>
                                                        </div>
                                                        <div className="font-semibold text-sm flex w-full items-center">
                                                            <div
                                                                className={`whitespace-nowrap flex space-x-2 items-center`}
                                                                style={{
                                                                    color: getStatusColor(
                                                                        item?.statusId
                                                                    ),
                                                                }}
                                                            >
                                                                {i18n.language ===
                                                                'en'
                                                                    ? item?.statusNameEn
                                                                        ? item?.statusNameEn
                                                                        : '-'
                                                                    : item?.statusNameTh
                                                                    ? item?.statusNameTh
                                                                    : '-'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>{' '}
                            </Link>
                        </>
                    ))
                ) : (
                    <div className="h-[35vh] grid items-center justify-center">
                        <div className="-mt-16">
                            <IconEmpty />
                        </div>
                    </div>
                )}
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={10}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </>
    );
}
